/**
 * ⚠️ BULLETPROOF AUTH SYSTEM - DO NOT MODIFY ⚠️
 * 
 * This file is part of the immutable auth system.
 * Any modifications will break the login flow.
 * 
 * If your feature needs auth changes, adapt your feature instead.
 * Authentication callback handler
 */

import React, { useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';

/**
 * BULLETPROOF AUTH CALLBACK
 * 
 * RULES:
 * 1. NO loading UI - causes complexity
 * 2. NO error handling UI - redirect on error
 * 3. NO toast notifications - they break the flow
 * 4. SIMPLE callback handling only
 * 5. ALWAYS redirect after processing
 */

const AuthCallback: React.FC = () => {
  const { handleCallback } = useAuthStore();

  useEffect(() => {
    // Handle the OAuth callback immediately
    const processCallback = async () => {
      try {
        await handleCallback();
        // handleCallback will redirect to /upload on success
        // or redirect to / on error
      } catch (error) {
        // If handleCallback fails, redirect to home
        window.location.href = '/';
      }
    };

    processCallback();
  }, [handleCallback]);

  // Return nothing - let the redirect happen
  return null;
};

export default AuthCallback;